module.exports = __webpack_public_path__ + "img/MEDIA105.037f6594.jpg";